import { render, staticRenderFns } from "./ApplicationsDetail.vue?vue&type=template&id=213398fc&scoped=true"
import script from "./ApplicationsDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetail.vue?vue&type=style&index=0&id=213398fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213398fc",
  null
  
)

export default component.exports